import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ExecutionResult, LcsApiService } from '@lcs/shared/api';
import { DepartmentInput } from 'generated/graphql-types';
import { Observable } from 'rxjs';
import { DepartmentDetailSaveModel } from '../../department-details/models/department-detail-save.model';
import { SaveDepartment, SaveDepartmentVariables } from '../../department-details/queries/generated/SaveDepartment';
import { SaveDepartmentMutation } from '../../department-details/queries/save-department.graphql';

@Injectable({ providedIn: 'root' })
export class AddDepartmentApiService {
   constructor(private apiService: LcsApiService, private http: HttpClient) {}

   create(departmentDetail: DepartmentDetailSaveModel): Observable<ExecutionResult<SaveDepartment>> {
      const fields: (keyof DepartmentInput)[] = ['name', 'accountId'];
      const department = { ...departmentDetail, fields };
      return this.apiService.query<SaveDepartment, SaveDepartmentVariables>({
         query: SaveDepartmentMutation,
         variables: {
            department,
         },
      });
   }
}
